import React from 'react'
import { Button, theme } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import styles from './HomePage.module.css'
import cgHeroImage from '../../assets/cgHeroImage.png'
import karolinska from '../../assets/karolinska.webp'
import { Link } from 'react-router-dom'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

export const HomePage = ({ user, googleUser }) => {
  const { IS_HOSPITAL } = useFeatureFlags()
  const { token } = theme.useToken()

  return (
    <div className={styles.heroContainer}>
      {IS_HOSPITAL ? (
        <div>
          <img src={karolinska} className={styles.gmckHeroImage} alt="Karolinska Hospital" />
        </div>
      ) : (
        <div>
          <img
            src={cgHeroImage}
            className={styles.cgHeroImage}
            alt="Clinical Genomics Stockholm Hero Image"
          />
        </div>
      )}

      <div className={styles.heroTitleBlock}>
        {IS_HOSPITAL ? (
          <h1>Karolinska GMCK | Order Portal</h1>
        ) : (
          <h1>Clinical Genomics Stockholm | Order Portal</h1>
        )}

        {(IS_HOSPITAL ? !user : !googleUser) ? (
          <>
            <h4>
              Sign in to place an order, or contact us at{' '}
              <a
                href="mailto:support@clinicalgenomics.se"
                style={{ color: 'black', fontStyle: 'italic' }}
              >
                support@clinicalgenomics.se
              </a>{' '}
              for project inquiries. For terms and conditions, see our{' '}
              <Link to="/policy" style={{ color: token.colorPrimary, fontWeight: 'bold' }}>
                Privacy Policy <LinkOutlined />
              </Link>
            </h4>
            <div className={styles.buttonContainer}>
              <Link to="/contact-us">
                <Button type="primary" size="large">
                  <span>Contact Us</span>
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className={styles.policyLink}>
              <p style={{ marginTop: '1rem', fontSize: '14px', color: 'black' }}>
                For terms and conditions, see our{' '}
                <Link to="/policy" style={{ color: token.colorPrimary, fontWeight: 'bold' }}>
                  Privacy Policy <LinkOutlined />
                </Link>
              </p>
            </div>

            <div className={styles.placeOrderButton}>
              <Link to={'/new-order'}>
                <Button type="primary" size="large">
                  <span>New Order</span>
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
